const getApiEnvironment = () => {
  let environment = 'local-dev'
  const {origin} = window.location
  const parts = origin.split('.')

  if (parts.length > 1) {
    environment = `staging-${parts[1]}`
  }
  return environment
}

export const metaData = {
  apiEnv: getApiEnvironment(),
  reactStage: process.env.REACT_APP_STAGE || process.env.NODE_ENV,
  nodeEnv: process.env.NODE_ENV,
}

const Config = {
  baseUrlApi: process.env.REACT_APP_API_ENDPOINT,
  baseUrlApiSecurity: process.env.REACT_APP_API_ENDPOINT_OCA_SECURITY,
  baseUrlApiCuadrilla: process.env.REACT_APP_API_ENDPOINT_CUADRILLA,
  baseUrlApiCheckList: process.env.REACT_APP_API_ENDPOINT_CHECKLIST,
}

export default Config
